module.exports = __webpack_public_path__ + "img/w10b.6e68f593.jpg";